/**
 * Calcula o SHA-256 (hex) de um valor via Web Crypto
 * @param value valor a ser hasheado
 */
async function sha256Hex(value: string): Promise<string> {
  const data = new TextEncoder().encode(value);
  const digest = await crypto.subtle.digest('SHA-256', data);

  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}

/**
 * Verifica se o valor recebido no query param `token` corresponde ao hash
 * configurado.
 * @param receivedValue valor bruto do query param `token`
 */
export async function isExceptionTokenValid(
  receivedValue: string,
): Promise<boolean> {
  const configuredHash = import.meta.env.VITE_APP_HASH_TOKEN_INSPECTION;

  if (!configuredHash || !receivedValue) {
    return false;
  }

  const decodedValue = decodeURIComponent(receivedValue);
  const receivedHash = await sha256Hex(decodedValue);

  return receivedHash === configuredHash;
}
